// extracted by mini-css-extract-plugin
export default {"offlineRibon":"AppShell-offlineRibon-hVV","banner":"AppShell-banner-33q"};